import { connect } from 'react-redux'
import { loadBuildings, addAlgoliaBuilding, removeAlgoliaBuilding } from 'Modules/user/alerts/buildingAlert/actions'
import { selectMobileBrowser } from 'Modules/app/selectors'

import ManageBuildings from './ManageBuildings'


const mapStateToProps = (state, props) => ({
  buildings: state.buildingAlert.buildings[props.alertId],
  mobileBrowser: selectMobileBrowser(state),
})

const actions = { loadBuildings, addAlgoliaBuilding, removeAlgoliaBuilding }

export default connect(mapStateToProps, actions)(ManageBuildings)
